export const closeLoggedSession = () => {
    localStorage.clear();

    window.location.href = "/login";

    return true;
};
